import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Flex,
  Form,
  message,
  Breadcrumb,
  Radio,
  Space,
  Card,
  Checkbox,
} from "antd";
import { useToken } from "../../common/helper";
import { useSpin } from "../../components/SpinContext.js";
import { SendNotification, GetNotificationById } from "../../api's/onboarding";
import {
  CustomTitle,
  CustomParagraph,
  CustomInput,
  CustomButton,
  CustomDynamicSelect,
  CustomSelect,
} from "../../components";
import {
  alertCardData,
  notificationFrequencyOptions,
} from "../../common/static_data.js";
import { CheckOutlined } from "@ant-design/icons";
import { selectProductState } from "../../reudx-toolkit/slice/ProductSlice.js";
import { useSelector } from "react-redux";

import { Table, Select, Input, Row, Col } from "antd";
import { ColumnsType } from "antd/es/table";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const SettingsNotificationsForm = () => {
  const [form] = Form.useForm();
  const { showSpin, hideSpin } = useSpin();
  const { token, removeToken } = useToken();
  const navigate = useNavigate();
  const { id } = useParams();
  const [model, setModelData] = useState({
    is_critical: false,
    is_at_risk: false,
    is_pickup_confirmation: false,
    is_delivery_confirmation: false,
  });
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [productList, setProductList] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const [makeFrequencyDisable, setMakeFrequencyDisable] = useState(false);
  const [value, setValue] = useState([]);
  const state = useSelector(selectProductState);

  useEffect(() => {
    if (state && state?.productList?.length > 0) {
      setProductList(state?.productList);
    }
  }, [state]);

  useEffect(() => {
    if (id) {
      GetSingleNotification(id);
    }
  }, [id]);

  //get notification by Id
  const GetSingleNotification = (id) => {
    showSpin();
    GetNotificationById(token, id)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let res = data?.data?.data ? data?.data?.data : null;
            const productIds = res?.products
              ? res.products.map((product) => product.id)
              : [];
            if (res) {
              setValue(res.alert_type);
              form.setFieldsValue({
                alert_type: res.alert_type,
                notification_method: res.notification_method,
                frequency: res.frequency,
                notification_channel: res.notification_channel,
                products: productIds,
                id: res.id,
              });
              setModelData(res);
              setSelectedOption(res.notification_method);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const onFinish = (values) => {
    if (values && Object.keys(values).length > 0) {
      let formModel = {
        ...model,
        ...form.getFieldsValue(),
      };
      if (formModel) {
        sendNotification(formModel);
      }
    }
  };
  const handleCardSelect = (value) => {
    setModelData((prevState) => ({
      ...prevState,
      [value]: !prevState[value], // Toggle the specific value
    }));
  };

  const onRadioChange = (e) => {
    const selectedValue = e.target.value;
    setValue(selectedValue);
    setMakeFrequencyDisable(false);
    if (selectedValue === "REAL_TIME") {
      form.setFieldsValue({ frequency: null });
      setMakeFrequencyDisable(true);
    }
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const sendNotification = (model) => {
    setIsFormValid(true);
    showSpin();
    SendNotification(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            FormReset();
            navigate("/settings/notification");
            message.success(data?.data?.message);
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
        setIsFormValid(false);
      });
  };

  const handleSelectChange = (value) => {
    setSelectedOption(value);
    let val1 =
      selectedOption === "MOBILE" || selectedOption === "WHATSAPP"
        ? true
        : false;
    let val2 = value === "MOBILE" || value === "WHATSAPP" ? true : false;
    if (val1 !== val2) {
      form.setFieldsValue({ notification_channel: "" });
    }
  };

  const FormReset = () => {
    form.resetFields();
    setModelData({
      is_critical: false,
      is_at_risk: false,
      is_pickup_confirmation: false,
      is_delivery_confirmation: false,
    });
    setSelectedOption(null);
    setValue(null);
  };

  // ==================================== [mahtab notificaiton ]

  const { Option } = Select;

  const frequencyOptions = [
    { value: "15MIN", label: "15MIN" },
    { value: "30MIN", label: "30MIN" },
    { value: "1HR", label: "1HR" },
    { value: "DAILY", label: "DAILY" },
    { value: "REAL_TIME", label: "REAL TIME" },
  ];

  const columns = [
    {
      title: "Notification Type",
      dataIndex: "alert_type",
      key: "alert_type",
      width: "20%",
    },
    {
      title: "Products",
      dataIndex: "products",
      key: "products",
      width: "25%",
      render: (products, record) => (
        <Select
          mode="multiple"
          style={{
            width: "100%",
            backgroundColor: "#f3f3f3",
            fontSize: "12px",
            borderRadius: "8px",
          }}
          placeholder="Select products"
          value={products}
          onChange={(value) => handleChange(record.key, "products", value)}
        >
          {productList.map((product) => (
            <Option key={product.id} value={product.id}>
              {product.name}
            </Option>
          ))}
          {/* <Option value="all">All Products</Option>  */}
        </Select>
      ),
    },
    {
      title: "Frequency",
      dataIndex: "frequency",
      key: "frequency",
      width: "15%",
      render: (frequency, record) => (
        <Select
          style={{
            width: "100%",
            backgroundColor: "#f3f3f3",
            fontSize: "12px",
            borderRadius: "8px",
          }}
          value={frequency}
          onChange={(value) => handleChange(record.key, "frequency", value)}
        >
          {frequencyOptions.map((item) => (
            <Option key={item.value} value={item.value}>
              {item.label}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Notification Channel",
      dataIndex: "notification_method",
      key: "notification_method",
      width: "20%",
      render: (channel, record) => (
        // <Select
        //   style={{ width: "100%" }}
        //   value={channel}
        //   onChange={(value) => handleChange(record.key, "channel", value)}
        // >
        //   <Option value="sms">SMS</Option>
        //   <Option value="email">Email</Option>
        //   <Option value="none">---</Option>
        // </Select>
        <Form.Item
          name="notification_method"
          rules={[
            { required: true, message: "Please select a notification method" },
          ]}
        >
          <CustomSelect
            placeholder="Select"
            onChange={(value) =>
              handleChange(record.key, "notification_method", value)
            }
            width={200}
            height="36px"
            border="0px"
            bgColor="#F3F3F3"
            textColor="#5E5E5E"
            borderRadius="8px"
            placeholderColor="#4B4B4B"
            options={[
              { value: "MOBILE", label: "Mobile" },
              { value: "EMAIL", label: "Email" },
              { value: "SLACK", label: "Slack" },
              { value: "TEAMS", label: "Teams" },
              { value: "WHATSAPP", label: "WhatsApp" },
            ]}
          />
        </Form.Item>
      ),
    },
    {
      title: "Send To",
      dataIndex: "notification_channel",
      key: "notification_channel",
      width: "20%",
      render: (notification_channel, record) =>
        record.notification_method === "MOBILE" ? (
          <PhoneInput
          country={"us"}
          value={notification_channel}
          onChange={(value, countryData, e, formattedValue) =>
            handleChange(record.key, "sendTo", formattedValue)
          }
        />
        
        ) : (
          <Input
            value={notification_channel}
            style={{ width: "100%" }}
            onChange={(e) => handleChange(record.key, "sendTo", e.target.value)}
          />
        ),
    },
  ];

  const [tableData, setTableData] = useState([
    {
      key: 1,
      alert_type: "Critical alert",
      products: [],
      frequency: "REAL_TIME",
      notification_method: "MOBILE",
      sendTo: "999-999-9999",
    },
    {
      key: 2,
      alert_type: "At-risk alert",
      products: [],
      frequency: "---",
      notification_method: "---",
      sendTo: "",
    },
    {
      key: 3,
      alert_type: "Pickup confirmation",
      products: [],
      frequency: "---",
      notification_method: "---",
      sendTo: "",
    },
    {
      key: 4,
      alert_type: "Delivery confirmation",
      products: [],
      frequency: "DAILY",
      notification_method: "email",
      sendTo: "phil@companyname.com",
    },
  ]);
  // Handle changes in table inputs
  const handleChange = (key, field, value) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.key === key ? { ...item, [field]: value } : item
      )
    );
  };

  return (
    <>
      <Flex justify="space-between" align="center">
        {id ? (
          <>
            <div className="custom-breadcrumbs">
              <Breadcrumb
                separator=""
                items={[
                  {
                    title: <a>Notifications</a>,
                    onClick: () => navigate("/settings/notification"),
                  },
                  {
                    title: "",
                  },
                ]}
              />
            </div>
          </>
        ) : (
          <CustomTitle
            text={"New Notification"}
            fontSize={24}
            fontWeight="700"
            lineHeight="32px"
            color="#000"
            marginBottom={0}
          />
        )}
      </Flex>

      <Form
        form={form}
        name="settingsNotificationForm"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Flex vertical={true} gap={32}>
          <Flex vertical={true}>
            <Space direction="vertical" size="small">
              <CustomTitle
                text="Notify me about..."
                fontSize="14px"
                fontWeight="500"
                lineHeight="16px"
                color="black"
                marginBottom="0"
              />
              <CustomParagraph
                text="Select all that apply"
                fontSize="14px"
                fontWeight="400"
                lineHeight="20px"
                color="#4B4B4B"
                marginBottom="8px"
              />
            </Space>

            <Form
              form={form}
              name="settingsForm"
              layout="vertical"
              onFinish={onFinish}
              autoComplete="off"
            >
              <Flex wrap vertical={true} gap={32}>
                <Space
                  direction="vertical"
                  style={{ width: "100%" }}
                  size="large"
                >
                  <Row gutter={[24, 16]}>
                      {alertCardData.map((card) => (
                    <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                        <Card
                          key={card.value}
                          onClick={() => handleCardSelect(card.value)}
                          style={{
                            width: "100%",
                            
                            borderRadius: "12px",
                            border: model[card.value]
                              ? "3px solid #000"
                              : "2px solid #EEEEEE",
                            cursor: "pointer",
                            padding: "0",
                          }}
                          className={model[card.value] ? "selected-card" : ""}
                          bodyStyle={{
                            padding: "16px",
                          }}
                        >
                          <Flex vertical={true} gap={16}>
                            <Flex justify="end">
                              <span className="custom-checkbox">
                                <CheckOutlined
                                  style={{
                                    color: "#fff",
                                    width: "inherit",
                                    fontSize: "16px",
                                  }}
                                />
                              </span>

                              <Checkbox
                                style={{ position: "absolute", opacity: 0 }}
                                checked={model[card.value]}
                                onChange={() => handleCardSelect(card.value)}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </Flex>
                            <CustomTitle
                              text={card.label}
                              fontSize="14px"
                              fontWeight="500"
                              lineHeight="16px"
                              color="black"
                              marginBottom="0"
                            />
                          </Flex>
                        </Card>
                    </Col>
                      ))}
                  </Row>

                  <Flex vertical={true} gap={8}>
                    <div style={{ maxWidth: "420px" }}>
                      <CustomTitle
                        text="For which products do you want to receive notifications?"
                        fontSize="14px"
                        fontWeight="500"
                        lineHeight="16px"
                        color="black"
                        marginBottom="8px"
                      />
                      <Form.Item
                        name="products"
                        rules={[
                          {
                            required: true,
                            message: "Please select at least one product",
                          },
                        ]}
                      >
                        <CustomDynamicSelect
                          mode="multiple"
                          allowClear={true}
                          placeholder="Please select"
                          options={productList}
                          width="100%"
                          height="36px"
                          border="0px"
                          bgColor="#F3F3F3"
                          textColor="#5E5E5E"
                          borderRadius="8px"
                          placeholderColor="#4B4B4B"
                        />
                      </Form.Item>
                    </div>
                  </Flex>

                  <Flex vertical={true} gap={16}>
                    <CustomTitle
                      text="Notification frequency"
                      fontSize="14px"
                      fontWeight="500"
                      lineHeight="16px"
                      color="black"
                      marginBottom="0"
                    />

                    <Flex wrap gap={16}>
                      <Form.Item name="alert_type">
                        <Flex gap={8} className="custom-radio-button-container">
                          <Radio.Group value={value}>
                            {notificationFrequencyOptions.map(
                              (option, index) => (
                                <Flex vertical={true} gap={16} key={index}>
                                  <Radio
                                    key={option.value}
                                    value={option.value}
                                    onChange={onRadioChange}
                                  >
                                    <CustomParagraph
                                      text={option.label}
                                      fontSize={14}
                                      lineHeight="20px"
                                      fontWeight="500"
                                      marginBottom={4}
                                      color="#000"
                                    />
                                    <CustomParagraph
                                      text={option.extraText}
                                      fontSize={14}
                                      lineHeight="20px"
                                      fontWeight="400"
                                      marginBottom={0}
                                      color="#4B4B4B"
                                    />
                                  </Radio>
                                </Flex>
                              )
                            )}
                          </Radio.Group>
                        </Flex>
                      </Form.Item>

                      <Form.Item
                        name="frequency"
                        style={{ alignSelf: "flex-end" }}
                      >
                        <CustomSelect
                        className="custom-select"
                          placeholder="Select frequency"
                          width="200px"
                          height="36px"
                          border="0px"
                          bgColor="#F3F3F3"
                          textColor="#5E5E5E"
                          borderRadius="8px"
                          placeholderColor="#4B4B4B"
                          disabled={makeFrequencyDisable}
                          options={[
                            { value: "15MIN", label: "Every 15 Mins" },
                            { value: "30MIN", label: "Every 30 Mins" },
                            { value: "1HR", label: "Every 1 Hour" },
                            // { value: "DAILY_12PM", label: "Every Day at 12PM Local Time" },
                            // { value: "DAILY_12PM_5PM", label: "Every Day at 12PM and 5PM Local Time" },
                            // { value: "DAILY_5PM", label: "Every Day at 5PM Local Time" },
                          ]}
                        />
                      </Form.Item>
                    </Flex>
                  </Flex>

                  <Space direction="vertical" style={{ width: "100%" }}>
                    <CustomTitle
                      text="Preferred notification method"
                      fontSize="14px"
                      fontWeight="500"
                      lineHeight="16px"
                      color="black"
                      marginBottom="0"
                    />
                    <Flex gap={8} wrap="wrap">
                      <Form.Item
                      className="custom-form-item"
                        name="notification_method"
                        rules={[
                          {
                            required: true,
                            message: "Please select a notification method",
                          },
                        ]}
                      >
                        <CustomSelect
                        className="custom-select"
                          placeholder="Select"
                          onChange={(value) => handleSelectChange(value)}
                          width={200}
                          height="36px"
                          border="0px"
                          bgColor="#F3F3F3"
                          textColor="#5E5E5E"
                          borderRadius="8px"
                          placeholderColor="#4B4B4B"
                          options={[
                            { value: "MOBILE", label: "SMS" },
                            { value: "EMAIL", label: "Email" },
                            { value: "SLACK", label: "Slack" },
                            { value: "TEAMS", label: "Teams" },
                            { value: "WHATSAPP", label: "WhatsApp" },
                          ]}
                        />
                      </Form.Item>

                      {selectedOption && (
                        <Form.Item
                          name="notification_channel"
                          rules={[
                            {
                              required: true,
                              message: `Please enter ${
                                selectedOption === "MOBILE" ||
                                selectedOption === "WHATSAPP"
                                  ? "mobile number"
                                  : "email"
                              }`,
                            },
                          ]}
                        >
                          {selectedOption === "MOBILE" ||
                          selectedOption === "WHATSAPP" ? (
                            <PhoneInput
                            country={"us"}
                            placeholder="Enter phone number"
                            value={form.getFieldValue("notification_channel")}
                            onChange={(value, countryData, e, formattedValue) => {
                              form.setFieldValue("notification_channel", formattedValue); // Store formatted phone number
                            }}
                          />
                          
                          ) : (
                            <CustomInput
                              value={form.getFieldValue("notification_channel")}
                              onChange={(e) =>
                                form.setFieldsValue({
                                  notification_channel: e.target.value,
                                })
                              }
                              type={"email"}
                              placeholder={"email@example.com"}
                              height="36px"
                              border="0px"
                              bgColor="#F3F3F3"
                              textColor="#5E5E5E"
                              borderRadius="8px"
                              placeholderColor="#5E5E5E"
                              lineHeight="38px"
                            />
                          )}
                        </Form.Item>
                      )}
                    </Flex>
                  </Space>
                </Space>

                {/* Save Button */}
                <CustomButton
                  text="Save"
                  width={138}
                  height={36}
                  borderRadius={8}
                  bgColor="#000"
                  color="#fff"
                  border="0px"
                  fontSize={14}
                  fontWeight={500}
                  onClick={form.submit}
                  isFormValid={isFormValid}
                />
              </Flex>
            </Form>
          </Flex>
        </Flex>
      </Form>

      {/* <div className="p-6">
      <Table 
      columns={columns} 
      dataSource={tableData} 
      pagination={false} 
      className="custom-table w-full" 
      rowHoverable={false} 
      />
    </div> */}
    </>
  );
};

export default SettingsNotificationsForm;
